import { useState } from "react"

import { isInStorybook, useOnMountEffect } from "@bounce/util"

import { Feature } from "@/config/flags"
import { useSSRExperiment } from "@/contexts/SSRExperiments"

const DEFAULT_INSTAGRAM_REEL_URL = "https://www.instagram.com/reel/DC2P4BJz1Z-/"
const INSTAGRAM_REELS_URLS = [
  DEFAULT_INSTAGRAM_REEL_URL,
  "https://www.instagram.com/reel/DC1r-tbxBp0/",
  "https://www.instagram.com/reel/DDIq2D5uC_9/",
]

export const useInstagramReel = () => {
  const [url, setUrl] = useState(DEFAULT_INSTAGRAM_REEL_URL)
  const { isEnabled } = useSSRExperiment({
    flagKey: Feature.AddInstagramReelsToReviewsSlider,
  })

  useOnMountEffect(() => {
    if (isInStorybook()) {
      return null
    }

    const randomIndex = Math.floor(Math.random() * INSTAGRAM_REELS_URLS.length)

    setUrl(INSTAGRAM_REELS_URLS[randomIndex] ?? DEFAULT_INSTAGRAM_REEL_URL)
  })

  return { isEnabled, url }
}
